import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Select} from "antd"

const {Option} = Select

class FilterSelect extends Component {
    _handleChange = (value) => {
        const {onChange, field} = this.props

        if (typeof onChange === 'function') {
            onChange(field, value)
        }
    }

    render() {
        const {label, options, defaultValue, field, value, filterStyle, allowClear, placeholder} = this.props

        return (
            <div className="FilterSelect">
                <div className='font-weight-bold mb-1'>{label}</div>
                <Select defaultValue={defaultValue} onChange={this._handleChange} value={value}
                        style={filterStyle||{width: 200}} name={field} allowClear={allowClear} placeholder={placeholder}>
                    {
                        !!options && options.length > 0 && options.map(item => {
                            return <Option key={item.value} value={item.value}>{item.name}</Option>
                        })
                    }
                </Select>
            </div>
        )
    }
}

FilterSelect.propTypes = {
    label: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    defaultValue: PropTypes.string,
    onChange: PropTypes.func.isRequired
}

export default FilterSelect